import axios from "axios";
import { loginUser } from '../features/loginSlice';
import { enableMFA } from '../features/mfaSlice';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://tvsmfaapi.dev-url.com/';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

const LoginRoute = "auth/login";
const RegisterRoute = "auth/register";
const Enable2FARoute = "2fa/enable-2fa";
const Verify2FARoute = "2fa/verify-2fa";
const EnableMFARoute = "User_EnableMFA/Enable";

export const LoginAPI = (payload) => {
  return axiosInstance.post(LoginRoute, payload);
};

export const RegisterAPI = (payload) => {
  return axiosInstance.post(RegisterRoute, payload);
};

export const Enable2FAAPI = (payload) => {
  return axiosInstance.post(Enable2FARoute, payload);
};

export const Verify2FAAPI = (payload) => {
  return axiosInstance.post(Verify2FARoute, payload);
};

export const EnableMFAAPI = (payload) => {
  return axiosInstance.post(EnableMFARoute, payload);
};

const Loginservice = {
  LoginAPI,
  RegisterAPI,
  Enable2FAAPI,
  Verify2FAAPI,
  EnableMFAAPI,
  loginUser,
  enableMFA
};

export default Loginservice;